import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { UserClassificationData } from "./@types";

export const useCloudUserClassificationQuery = (
  sampleHashes: Array<string>,
  cloudEnabled: boolean
) =>
  useQuery<UserClassificationData>({
    queryKey: ["userClassification", "cloud", sampleHashes],
    queryFn: () =>
      api
        .getUserBulkCloudClassification({ hashValues: sampleHashes })
        .then(r => r.data),
    enabled: cloudEnabled
  });

export const useLocalUserClassificationQuery = (sampleHashes: Array<string>) =>
  useQuery<UserClassificationData>({
    queryKey: ["userClassification", "local", sampleHashes],
    queryFn: () =>
      api
        .getBulkUserClassification({ hashValues: sampleHashes })
        .then(r => r.data)
  });
